// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver, ProductData } from '../../contexts'
import { logger } from '../../support'

import { resolveProduct, resolveProducts } from '../resolvers'

import { ProductsTeaserModuleContent, ProductsTeaserModuleContentInput } from './ProductsTeaser.contracts'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const resolveProductsTeaserModuleContent: ModuleContentResolver<ProductsTeaserModuleContentInput, ProductsTeaserModuleContent> =
  async (input: ProductsTeaserModuleContentInput, relatedService: IRelatedService): Promise<ProductsTeaserModuleContent> => {
    let products: ProductData[] = []

    if (input.products) {
      try {
        products = await resolveProducts(input.products, relatedService)
      } catch (e) {
        logger(e, 'warn')
      }
    } else if (input.product) {
      try {
        const resolvedProducts = await Promise.all(input.product.map(async (product) => {
          return await resolveProduct(product, relatedService)
        }))

        products = resolvedProducts.filter(product => product !== null) as ProductData[]
      } catch (e) {
        logger(e, 'warn')
      }
    }

    return {
      ...input,
      products
    }
  }
